var _ellipse, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDiseaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 10.3654,
    rx: 10.5,
    ry: 10.3654,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.17627,
    y: 6.09717,
    width: 8.64706,
    height: 8.53622,
    stroke: "#979797",
    strokeOpacity: 0.01,
    strokeWidth: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7899 10.6516L13.8664 10.6516C14.0265 10.6517 14.1565 10.5234 14.1564 10.3653C14.1564 10.2072 14.0266 10.0791 13.8664 10.0791L10.7899 10.0791L10.79 7.04207C10.79 6.8839 10.6602 6.75583 10.5 6.75583C10.3399 6.7557 10.2099 6.88404 10.21 7.04208L10.21 10.0791L7.13352 10.0792C6.97344 10.079 6.84343 10.2074 6.84356 10.3654C6.84356 10.4445 6.8761 10.516 6.92859 10.5678C6.98109 10.6197 7.05341 10.6516 7.13352 10.6516L10.21 10.6516L10.21 13.6887C10.21 13.7677 10.2425 13.8393 10.295 13.8911C10.3475 13.9429 10.4198 13.9749 10.4999 13.9749C10.66 13.975 10.79 13.8467 10.7899 13.6887L10.7899 10.6516Z",
    fill: "#00AF91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7899 10.6516L13.8664 10.6516C14.0265 10.6517 14.1565 10.5234 14.1564 10.3653C14.1564 10.2072 14.0266 10.0791 13.8664 10.0791L10.7899 10.0791L10.79 7.04207C10.79 6.8839 10.6602 6.75583 10.5 6.75583C10.3399 6.7557 10.2099 6.88404 10.21 7.04208L10.21 10.0791L7.13352 10.0792C6.97344 10.079 6.84343 10.2074 6.84356 10.3654C6.84356 10.4445 6.8761 10.516 6.92859 10.5678C6.98109 10.6197 7.05341 10.6516 7.13352 10.6516L10.21 10.6516L10.21 13.6887C10.21 13.7677 10.2425 13.8393 10.295 13.8911C10.3475 13.9429 10.4198 13.9749 10.4999 13.9749C10.66 13.975 10.79 13.8467 10.7899 13.6887L10.7899 10.6516",
    stroke: "#00AF91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDiseaseIcon);
export default __webpack_public_path__ + "static/media/addDiseaseIcon.c40e85fc518c95b8d9d630527e95b6e4.svg";
export { ForwardRef as ReactComponent };